import type { TranslationKey } from './en'

// Ecuador-specific Spanish overrides (keep this file tiny).
export const esEC: Partial<Record<TranslationKey, string>> = {
  // Example override slot.
}
